import BaseService from './BaseService';
import Store from '../store';
import axios from 'axios'
import { ACCOUNT_DOLOGIN, ACCOUNT_UPDATE_PROFILE, ACCOUNT_UPDATE_TOKEN, ACCOUNT_CACTE_STATE } from '../store/mutation';

class AccountService extends BaseService {
    constructor() {
        super();
        this.accountUrl = '/api/account/'
    }

    hasProfile() {
        return Store.getters.accountId;
    }

    login(account, password, vcode = '') {
        return this.request(this.accountUrl + 'login', { account, password, vcode }).then((res) => {
            if (res.account_token) {
                this.cleanUserAccountCache();
                Store.commit(ACCOUNT_UPDATE_TOKEN, res.account_token);
            } else {
                throw new Error('获取登录令牌失败。');
            }
        })
    }

    register(model) {
        return this.request(this.accountUrl + 'register', model).then((res) => {
            if (res.account_token) {
                this.cleanUserAccountCache();
                Store.commit(ACCOUNT_UPDATE_TOKEN, res.account_token);
            } else {
                throw new Error('获取登录令牌失败。');
            }
        })
    }

    getVcode(mobile) {
        return this.request('/api/sms/key').then((ret) => {
            if (ret) {
                return ret;
            } else {
                throw new Error('获取验证码失败');
            }
        }).then((key) => {
            return this.request('/api/sms/getvcode', { key, mobile });
        })
    }

    getLoginVcode(mobile) {
        return this.request('/api/sms/key').then((ret) => {
            if (ret) {
                return ret;
            } else {
                throw new Error('获取验证码失败');
            }
        }).then((key) => {
            return this.request('/api/sms/getloginvcode', { key, mobile });
        })
    }

    getResetVcode(mobile) {
        return this.request('/api/sms/userkey').then((ret) => {
            if (ret) {
                return ret;
            } else {
                throw new Error('获取验证码失败');
            }
        }).then((key) => {
            return this.request('/api/sms/getresetvcode', { key, mobile });
        })
    }

    checkMobile(mobile) {
        return this.request(this.accountUrl + 'check', { mobile });
    }

    logout() {
        Store.commit(ACCOUNT_CACTE_STATE, {});
        this.cleanUserAccountCache();
        return this.createPromise(() => {
        });
    }

    //清楚当前登录用户的缓存;
    cleanUserAccountCache() {
        this.SessionStorage.clear();
    }

    /**
     * 初始化用户资料
     * @param {number} id
     * @return {*}
     */
    initAccount() {
        return this.request(this.accountUrl + 'profile').then(function (response) {
            if (response && response.id) {
                Store.commit(ACCOUNT_UPDATE_PROFILE, response);
            } else {
                throw new Error('获取用户资料失败。');
            }
            return response;
        });
    }

    getProfile(id) {
        return this.request(this.accountUrl + 'profile/' + id, null, 'get');
    }

    updateprofile(model) {
        return this.request(this.accountUrl + 'updateprofile', model).then(function (response) {
            if (response && response.id) {
                Store.commit(ACCOUNT_UPDATE_PROFILE, response);
            } else {
                throw new Error('保存失败。');
            }
            return response;
        });
    }

    updateProfileById(id, model) {
        return this.request(this.accountUrl + 'profile/' + id, model)
    }

    createdProfile(model) {
        return this.request(this.accountUrl + 'created', model)
    }

    resetpassword(model) {
        return this.request(this.accountUrl + 'resetpassword', model);
    }

    resetmobile(model) {
        return this.request(this.accountUrl + 'resetmobile', model);
    }

    setStoreCache(state) {
        this.SessionStorage.set('account_state_cache', state);
    }

    loadStoreCache() {
        let state = this.SessionStorage.get('account_state_cache');
        if (state) {
            Store.commit(ACCOUNT_CACTE_STATE, state);
        }
    }

    checklogin() {
        return !!Store.getters.accountToken;
    }

    forgetpassword(model) {
        return this.request('/api/account/forgetpassword', model).then((res) => {
            if (res.account_token) {
                this.cleanUserAccountCache();
                Store.commit(ACCOUNT_UPDATE_TOKEN, res.account_token);
            } else {
                throw new Error('获取登录令牌失败。');
            }
        });
    }

    uploadImage(FormData) {
        return this.request('/api/attach/upload', FormData);
    }

}

export default new AccountService();



// WEBPACK FOOTER //
// ./src/services/AccountService.js